import { ReportModalBean } from "../../report/ReportModalBean";
import exportTemplate from './exportComponent.html';
import { ExportModalBean } from "../../export/ExportModalBean";
import { downloadSettingsValueKey } from "fides-angularjs-components/src/fts-administration/fts-exportDownload-settings/fts-download-settings";
import { EXPORT_TYPE } from "../../export/ExportModalController";
import { USERREPORT_ACCOUNTROUTE } from "../../../views/accounts/AccountController";
import { EXPORT_MODAL } from "../../../routes/export.route";

/** @ngInject */
export function exportComponent() {
    return {
        restrict: 'E',
        scope: {
            parentController: '=',
            hooverText: '@',
            withDownload: '=',
            withExport: '=',
            exportText: '='
        },
        templateUrl: exportTemplate,
        controller: ExportController,
        controllerAs: 'exportController'
    };
}

/** @ngInject */
export class ExportController {
    constructor($scope, $rootScope, arsMainDependencies) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$mdDialog = arsMainDependencies.$mdDialog;
        this.state = arsMainDependencies.$state;
        this.exportText = $scope.exportText || 'EXPORT_CSV_HOOVER';

        this.REPORT_MODAL = {
            templateUrl: 'app/components/report/report-modal.html',
            controller: 'ReportModalController',
            controllerAs: 'vm',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            multiple: true,
            resolve: { reportModalBean: () => new ReportModalBean(this.$scope.parentController.supportedReports,
                    this.$scope.parentController.withDateRange, this.$scope.parentController.withLastAndUnread) }
        };

        this.USERREPORTSTATE = this.state.get(USERREPORT_ACCOUNTROUTE);
        this.USER_REPORT_MODAL = {
            templateUrl: this.USERREPORTSTATE.templateUrl,
            controller: this.USERREPORTSTATE.controller,
            controllerAs: this.USERREPORTSTATE.controllerAs,
            backdrop: 'static',
            keyboard: false,
            multiple: true
        };

        let totalElements = 0;
        $scope.$on('populated', (event, params) => {
            totalElements = totalElements + params.selected.length;
            // different multiple selection on different groups selection
            this.state._params.ids = this.state._params.ids ?
                this.state._params.ids.concat(params.selected) : params.selected;
            // opens only one user report at a time
            if(params.tableId){  // called for reporting on table group level component
                this.showAndResetUserReport();
            }else if(totalElements === this.$rootScope.checkElements) {
                // option for multiple groups indiv. selection, from report filter component
                this.showAndResetUserReport();
            }
        });
    }

    checkSelectedIems() {
        this.$scope.parentController.checkForSelection();
        if(this.$rootScope.checkElements === 0 ){
            this.$scope.parentController.infoPop('NO_ROW_SELECTED');
            return false;
        } else if(this.$rootScope.overLimit) {
            return false;
        }

       return this.$rootScope.overLimit ? false : true;

    }

    checkExport() {
        const userSettings = this.$scope.parentController.sessionPersistance.get(downloadSettingsValueKey);
        const exportFormat = userSettings ? userSettings.exportFormat : 'SETTINGS_EXPORTFORMAT_OPTION_NONE';

        this.$rootScope.exportFromGroup = false;
        if(exportFormat === 'SETTINGS_EXPORTFORMAT_OPTION_NONE') {
            this.openExport();
        } else {
            this.broadcastOption(
                exportFormat === 'SETTINGS_EXPORTFORMAT_OPTION_CSV' ? EXPORT_TYPE.CSV : EXPORT_TYPE.XLS);
        }
    }

    openExport() {
        // delete possible group definition
        EXPORT_MODAL.resolve = {
            exportModalBean: () => new ExportModalBean(this.$scope.parentController.supportedExports,{ }, undefined)
        };
        this.openPopup(EXPORT_MODAL);
    }

    openReport() {
        if(this.checkSelectedIems()) {
            this.openPopup(this.REPORT_MODAL);
        }
    }

    showAndResetUserReport() {
        this.$mdDialog.show(this.USER_REPORT_MODAL).catch(() => {
            // reset for next selection
            this.$rootScope.checkElements = 0;
            this.state._params.ids = [];
        });
    }

    openPopup(popUpOption) {
        if(this.checkSelectedIems()) {
            this.$mdDialog.show(popUpOption).catch(() => {});
        }
    }

    broadcastOption(selectedExport){
        this.$rootScope.$broadcast('export', {reportType: selectedExport, userFunction: selectedExport.userFunction });
    }
}
